/**
 * Counts the total number of questions from itemGroups structure
 * @param {Array} itemGroups - Array of item group objects
 * @returns {number} Total count of questions across all itemGroups
 *
 * @example
 * const itemGroups = [
 *   {
 *     items: [
 *       { questions: { "172751": 1, "370638": 1 } },
 *       { questions: { "535826": 1 } }
 *     ]
 *   }
 * ]
 * getQuestionsCountFromItemGroups(itemGroups) // returns 3
 */
export const getQuestionsCountFromItemGroups = (itemGroups = []) => {
  if (!Array.isArray(itemGroups) || itemGroups.length === 0) {
    return 0
  }

  let totalQuestions = 0

  for (const itemGroup of itemGroups) {
    if (!itemGroup.items || !Array.isArray(itemGroup.items)) {
      continue
    }

    for (const item of itemGroup.items) {
      if (item.questions && typeof item.questions === 'object') {
        // Count the number of keys in the questions object
        totalQuestions += Object.keys(item.questions).length
      }
    }
  }

  return totalQuestions
}
